import { StepAction } from './stepAction';
import { delay } from '../../utils';
import type { SleepStep } from 'clickim/src/common/models/sleepStep';

export class SleepStepAction extends StepAction<SleepStep> {
    override async performAction() {
        await delay(this.step.durationMS || 0);
    }
}
